
import { CheckCircle2 } from "lucide-react";
import React from "react";

const documents = [
    "Scanned color copy of the applicant's passport.",
    "The passport must be valid for at least six months.",
    "Scanned color copy of the applicant's passport-size photograph with a white background.",
    "For children, a birth certificate is also required."
];

export function RequiredDocuments() {
    return (
        <div>
            <div className="mb-6">
                <h2 className="text-3xl font-bold">Required Documents for Dubai Tourist Visa from us</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                {documents.map((doc, index) => (
                    <div key={index} className="flex items-start">
                        <CheckCircle2 size={20} className="text-green-500 mr-3 mt-1 flex-shrink-0" />
                        <span className="text-neutral-600">{doc}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
